import React, { useEffect, useState } from 'react';
import SideBar from '../../Layout/Sidebar'
import UserNFT from './UserNFT';
import Nutrition from './Nutrition';
import Uploads from './Uploads';
import Consultant from './Consultant';
import MyDNA from './MyDNA';
import UserWallet from './UserWallet'
import axios from 'axios';
import { SERVER_URL } from '../../../config';
import CountryList from '../../../country.json'
import toast from 'react-hot-toast';
import { useNavigate } from "react-router-dom";
import MySoccer from './MySoccer';

export default function UserDashboard() {

    const [active, setActive] = useState('div1')
    const [playerData, setPlayerData] = useState([]);
    const [dietReportData, setDeitReportData] = useState(null);
    const [soccerReportData, setSoccerReportData] = useState(null);
    const navigate = useNavigate();

    const token = sessionStorage.getItem('player_token');

    const tabs = [
        { id: 'div1', label: 'MY NFT', icon: 'tag' },
        { id: 'div2', label: 'MY DNA', icon: 'dna' },
        { id: 'div3', label: 'MY Soccer', icon: 'soccer' },
        { id: 'div4', label: 'NUTRITION', icon: 'nutri' },
        { id: 'div5', label: 'Uploads', icon: 'booktag' },
        { id: 'div6', label: 'Consult Form', icon: 'booktag' },
        { id: 'div7', label: 'WALLET', icon: 'wallet' },
    ]

    useEffect(() => {
        const fetchDietReport = async () => {
            try {
                const response = await axios.get(`${SERVER_URL}/api/v2/get-user-diet-report`, {
                    headers: { Authorization: `Bearer ${token}`, }
                });
                if (response.data.status) {
                    setDeitReportData(response.data.data);
                }
            } catch (err) {
                console.error("Failed to fetch diet report.", err);
                if (err.response?.status === 403) {
                    toast.error(`${err?.response?.data?.error?.msg}`);
                    setTimeout(() => {
                        toast.dismiss()
                        navigate('/player/Login');
                    }, 1500);
                }
            }
        };

        const fetchSoccerReport = async () => {
            try {
                const response = await axios.get(`${SERVER_URL}/api/v2/get-user-soccer-report`, {
                    headers: { Authorization: `Bearer ${token}`, }
                });
                if (response.data.status) {
                    setSoccerReportData(response.data.data);
                }
            } catch (err) {
                console.error("Failed to fetch soccer report.", err);
                if (err.response?.status === 403) {
                    toast.error(`${err?.response?.data?.error?.msg}`);
                    setTimeout(() => {
                        toast.dismiss()
                        navigate('/player/Login');
                    }, 1500);
                }
            }
        };

        get_player_data();
        fetchDietReport();
        fetchSoccerReport();
    }, [token]);

    const get_player_data = async () => {
        try {
            const response = await axios.get(`${SERVER_URL}/api/v2/get-player-data`, {
                headers: { Authorization: `Bearer ${token}`, }
            });
            if (response.data.status === true) {
                setPlayerData(response.data.data);
            } else {
                setPlayerData([])
            }
        } catch (error) {
            console.error("Error checking the player profile : ", error);
            if (error.response?.status === 403) {
                toast.error(`${error?.response?.data?.error?.msg}`);
                setTimeout(() => {
                    toast.dismiss()
                    navigate('/player/Login');
                }, 1500);
            }
        }
    }

    const handleActivetab = (id) => {
        setActive(id);
    }

    return (
        <div className='flex flex-col h-screen bg-[#0E081B] text-white'>
            <div className='flex flex-col flex-grow lg:flex-row overflow-hidden'>
                <SideBar />
                <div className='w-[100%] lg:w-[90%] p-5 lg:px-10 overflow-y-auto pt-10 lg:pt-20'>
                    <div className='flex overflow-x-auto'>
                        {tabs.map((item) => {
                            const { id, label, icon } = item;
                            return (
                                <div key={id} className={`flex-shrink-0 border uppercase border-white/15 rounded-t-xl px-10 py-1.5 flex items-center gap-3 cursor-pointer 
                                    ${active === id ? 'text-[#00FF00] font-semibold' : ''}`}
                                    onClick={() => handleActivetab(id)}>
                                    <img src={`/assets/icon/${active === id ? `${icon}.svg` : `${icon}white.svg`}`} className=''></img>
                                    {label}
                                </div>
                            );
                        })}
                    </div>
                    {active === 'div1' && <UserNFT playerData={playerData} getPlayerData={get_player_data} />}
                    {active === 'div2' && <MyDNA soccerReportData={soccerReportData} />}
                    {active === 'div3' && <MySoccer  />}
                    {active === 'div4' && <Nutrition dietReportData={dietReportData} />}
                    {active === 'div5' && <Uploads  />}
                    {active === 'div6' && <Consultant />}
                    {active === 'div7' && <UserWallet />}
                </div>
            </div>
        </div>
    )
}
